import React from 'react';
import { Link } from 'react-router-dom';
import { FiLock, FiArrowRight } from 'react-icons/fi';
import { ROUTES } from '../../app/routes';
import '../../styles/UpgradeBanner.css';

interface UpgradeBannerProps {
  feature?: string;
}

const UpgradeBanner: React.FC<UpgradeBannerProps> = ({
  feature = 'advanced features',
}) => {
  return (
    <div className="upgrade-banner glass-card">
      <div className="upgrade-banner__icon">
        <FiLock size={20} />
      </div>
      <div className="upgrade-banner__content">
        <h3 className="upgrade-banner__title">
          Sign up to unlock {feature}
        </h3>
        <p className="upgrade-banner__desc">
          Get access to analytics dashboard, channels, workflows, and more.
        </p>
      </div>
      <div className="upgrade-banner__actions">
        <Link to={ROUTES.SIGNUP} className="glass-btn glass-btn-primary upgrade-banner__btn">
          Sign Up Free <FiArrowRight size={14} />
        </Link>
        <Link to={ROUTES.LOGIN} className="upgrade-banner__login-link">
          Already have an account?
        </Link>
      </div>
    </div>
  );
};

export default UpgradeBanner;
